import * as Sentry from "@sentry/vue";

import { ApiClientError } from "@/api/api-client-error.ts";
import { isExpectedError } from "@/lib/error-reporting.ts";

type SentryOptions = NonNullable<Parameters<typeof Sentry.init>[0]>;

export const filterExpectedErrors: NonNullable<SentryOptions["beforeSend"]> = (event, hint) => {
  const error = hint.originalException;
  if (isExpectedError(error)) {
    return null;
  }

  if (error instanceof ApiClientError) {
    event.tags = {
      ...event.tags,
      "api.backend": error.backend,
      "api.error.classification": error.classification,
      "http.response.status_code": error.status,
    };
    event.contexts = {
      ...event.contexts,
      api: {
        method: error.method,
        url: error.url,
        status: error.status,
        details: error.details,
      },
    };
  }

  return event;
};

export function captureNonBlockingError(error: Error | string, context?: object): void {
  const errorObj = typeof error === "string" ? new Error(error) : error;

  console.error(errorObj, context ?? {});

  Sentry.withScope((scope) => {
    if (context) {
      scope.setExtra("context", context);
    }
    Sentry.captureException(errorObj);
  });
}
